import { RSAA } from 'redux-api-middleware';
export const Actions = {
    RegisterSetData: 'RegisterSetData',
    QuestionnaireStart: 'QuestionnaireStart',
    QuestionnaireSetData: 'QuestionnaireSetData',
};
export function generateRequest({ body, endpoint, method, ...options }) {
    return {
        [RSAA]: {
            endpoint,
            method,
            headers: {
                'Content-Type': 'application/json',
            },
            body: body && JSON.stringify(body),
            ...options,
        },
    };
}
